import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';
import { queryFunction, queryKey } from './query';

export const useVisualSearch = ({
  files,
  searchQuery,
  metadataFilters,
  folders,
  extensions,
  page,
  perPage,
  enabled,
  tenantId,
}: {
  files?: File[];
  searchQuery?: string;
  metadataFilters?: string;
  folders?: string;
  extensions?: string;
  page?: number;
  perPage?: number;
  enabled?: boolean;
  tenantId?: string;
}) => {
  const { getTenantId } = useTenants();
  const tenantIdValue = tenantId || getTenantId();

  const hasFiles = files && files.length > 0;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: queryKey({
      files: hasFiles ? files : [],
      searchQuery: searchQuery ?? '',
      metadataFilters,
      folders,
      extensions,
      page,
      perPage,
      tenantId: tenantIdValue,
    }),
    queryFn: queryFunction({
      files: hasFiles ? files : [],
      searchQuery: searchQuery ?? '',
      metadataFilters,
      folders,
      extensions,
      page,
      perPage,
      tenantId: tenantIdValue,
    }),
    select: data => data.data,
    retry: false,
    enabled: (enabled ?? hasFiles) && !!tenantIdValue,
  });

  return {
    data,
    isLoading,
    isError,
    error: getApiError(error),
  };
};
